<section class="sec-container" [@enterAnimation]>
	<div
		class="row user-card shadow google-calendar-widget"
		[pTooltip]="
			!isPremiumUser && ('TOOLTIPS.GOOGLE_CALENDAR.ONLY_PREMIUM' | translate)
		"
		tooltipPosition="bottom"
		*ngIf="hasData"
	>
		<div class="header">
			<img
				class="gcalendar-icon"
				alt="Google Calendar"
				src="/assets/images/icons/google-calendar.svg"
			/>

			<p>{{ 'GOOGLE_CALENDAR.WIDGET.TITLE' | translate }}</p>

			<freud-button
				*ngIf="isPremiumUser"
				color="ghost"
				type="button"
				[loading]="this.isWaitingNewData"
				(click)="openModal()"
			>
				{{
					isCalendarConnected
						? ('GOOGLE_CALENDAR.WIDGET.DISCONNECT' | translate)
						: ('GOOGLE_CALENDAR.WIDGET.CONNECT' | translate)
				}}
			</freud-button>

			<div *ngIf="!isPremiumUser">
				<span class="freud-icon freud-icon-lock-icon freud-icon-md"></span>
			</div>
		</div>

		<div *ngIf="!isCalendarConnected" class="info">
			{{ 'GOOGLE_CALENDAR.WIDGET.INFO' | translate }}
		</div>

		<div *ngIf="isCalendarConnected" class="info">
			<span
				class="freud-icon freud-icon-circle-check freud-icon-xs check-icon"
			></span>

			<p>{{ 'GOOGLE_CALENDAR.WIDGET.CONNECTED' | translate }}</p>
		</div>
	</div>
</section>
